"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePopper = usePopper;
var React = _interopRequireWildcard(require("react"));
var _reactUtils = require("@cian/react-utils");
var _popperFork = require("@cian/popper-fork");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-explicit-any */

function usePopper(props) {
  const {
    open,
    anchorRef
  } = props;
  const {
    placement,
    modifiers,
    strategy,
    onFirstUpdate
  } = props.options || {};
  const instanceRef = React.useRef(null);
  const popperRef = React.useRef(null);
  const instance = instanceRef.current;
  const state = instance && instance.state;
  const options = React.useMemo(() => {
    return Object.fromEntries(Object.entries({
      placement,
      modifiers,
      strategy,
      onFirstUpdate
    }).filter(entry => entry[1] !== undefined));
  }, [modifiers, onFirstUpdate, placement, strategy]);
  React.useEffect(() => {
    if (!open) {
      return;
    }
    return () => {
      if (instanceRef.current) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, [open]);
  const tryOpen = React.useCallback(() => {
    const popperEl = popperRef.current;
    const anchorEl = anchorRef.current;
    if (!open || !anchorEl || !popperEl) {
      return;
    }
    if (instanceRef.current) {
      instanceRef.current.destroy();
      instanceRef.current = null;
    }
    instanceRef.current = (0, _popperFork.createPopper)(anchorEl, popperEl, options);
  }, [anchorRef, open, options]);
  const handleRef = React.useCallback(node => {
    popperRef.current = node;
    tryOpen();
  }, [tryOpen]);
  (0, _reactUtils.useIsomorphicLayoutEffect)(() => {
    // Обновление позиции, на случай если компонент сместился
    if (instanceRef.current) {
      instanceRef.current.forceUpdate();
    }
  });
  return {
    ref: handleRef,
    attributes: state && state.attributes.popper,
    style: state && state.styles.popper
  };
}